import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { use_effect } from '@/hooks/_base/use_effect';
import { ENUM__environment_type } from '@shared/enums/ENUM__environment_type';
import { useRef } from 'react';

export function WATCHER_DebugReloadPageAfterError() {
  const ref_is_error = useRef(false);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (CONSTANTS__environment_client.VITE_APP_ENVIRONMENT != ENUM__environment_type.LOCAL) return;
    if (!import.meta.hot) return;

    import.meta.hot.on('vite:beforeUpdate', on_vite_before_update);

    register_error_handler();
  }, []);

  /*
   * EVENTS
   */
  function on_vite_before_update() {
    if (!ref_is_error.current) return;
    ref_is_error.current = false;

    window.location.reload();
  }

  function on_error() {
    ref_is_error.current = true;
  }

  /*
   * METHODS
   */

  function register_error_handler() {
    window.addEventListener('error', on_error);
    window.addEventListener('unhandledrejection', on_error);
  }

  return null;
}
